<template>
  <BTableCommon
    type="publication-formdata-history"
    :list="history"
    :loading="isLoading"
    :skeleton="isLoadingAsyncData"
    style="max-height: 100%; overflow: auto;"
  />
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { LKFormdataStoreModule as StoreModule } from './store'
import { LkFormdataModel as Model } from './Model'

import BTableCommon from '@/components/tables/BTableCommon.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

export default {
  name: 'LKPublicationsFormdataHistoryList',
  components: {
    BTableCommon,
  },
  mixins: [
    listMixin,
  ],
  inheritAttrs: false,
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data: (vm) => ({
    defaultParams: {
      id: vm.id,
    },
  }),
  computed: {
    getAll() {
      return this.storeModule.actions.history
    },
    history() {
      return this.storeModule.state.history
    },
  },
}
</script>
